export default function gtmService(){
  const w = window;
  w.dataLayer = w.dataLayer || [];

  const GTM_ACTIONS = {
    'ADS:ACTIONS:AD_BLOCK_DETECTION_FINISHED': {
      gtmEventName: 'GTM late data to GA',
      eventKeyName: 'isAdBlock',
      valuePath: 'state.detected',
      normalizeDataFunction: 'normalizeAdblockData',
      dataConverters: {
        val__true: 'yes',
        val__false: 'no'
      },
    },

    'ANALYTICS:ACTIONS:SCROLL_ANCHOR_REACHED': {}
  };

  function unlessStringToString(value) {
    return (typeof value !== 'string') ? value.toString() : value;
  }

  function normalizeEventData(eventPayload) {
    return Object
        .entries(eventPayload)
        .reduce((acc, [key, value]) => {
          return value === undefined ?
              acc :
              { ...acc, [`GA_event_${key}`]: unlessStringToString(value).toLowerCase() };
    }, { event: 'GTM event To GA' });
  }


  const dataConverters = {
    normalizeAdblockData(state){
      const isAdBlocked = (state.detected) ? 'yes' : 'no';

      return {event: 'GTM late data to GA', 'isAdBlock': isAdBlocked};
    }
  };


  return function gtmPushToDataLayer(gtmReduxAction){
    const currentGtmAction = GTM_ACTIONS[gtmReduxAction.type];

    if (currentGtmAction !== undefined){
      let finalNormalizedGtmData;

      const {
          category,
          action,
          label,
          sub_label,
          } = gtmReduxAction.state.payload || {};

      if (category && action && label) {
        finalNormalizedGtmData = normalizeEventData({ category, action, label, sub_label });
      }
      else{
        finalNormalizedGtmData = dataConverters[currentGtmAction.normalizeDataFunction](gtmReduxAction.state);
      }

      w.dataLayer.push(finalNormalizedGtmData);
    }
  };
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/GtmService.js